import { render, staticRenderFns } from "./ElementFullscreen.vue?vue&type=template&id=42be67ed"
import script from "./ElementFullscreen.vue?vue&type=script&lang=js"
export * from "./ElementFullscreen.vue?vue&type=script&lang=js"
import style0 from "./ElementFullscreen.vue?vue&type=style&index=0&id=42be67ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports